import { useTranslation } from 'react-i18next';
import { ApiError } from '@/lib/apiClient';
import { Icon } from './Icon';

/** Renders an API failure as a readable line, falling back to a generic message. */
export function ErrorBanner({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  if (!error) return null;

  const message =
    error instanceof ApiError
      ? error.message === 'sessionExpired'
        ? t('errors.sessionExpired')
        : error.message
      : t('common.error');

  return (
    <div className="flex items-start gap-2.5 rounded-xl border border-danger-border bg-danger-bg px-3.5 py-3">
      <Icon name="error" className="mt-px shrink-0 text-[17px] text-danger-text" />
      <div className="min-w-0 flex-1 text-[12px] leading-relaxed text-danger-text">{message}</div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 text-[12px] font-semibold text-danger-text underline"
        >
          {t('common.retry')}
        </button>
      )}
    </div>
  );
}
